import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Reserach from '@/view/research/Research'

export default {
  path: '/research',
  name: 'Research',
  components: {
    default: Reserach,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'research',
    area: 'research',
    breadcrumb: [
      { name: 'Pesquisa' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/research/ResearchRoute.js